import * as React from "react";
import {useRef, useState} from "react";
import {MagnifyingGlassIcon, XMarkIcon} from "@heroicons/react/24/outline";

type Props = {
    value: string
    onChange: (v: string) => void
    placeholder?: string
    className?: string
    inputClassName?: string
    buttonClassName?: string
    widthOpenClass?: string
    initialOpen?: boolean
    autoFocusOnOpen?: boolean
}

export default function SearchSlideInput({
    value,
    onChange,
    placeholder = "Typ om te zoeken",
    className = "",
    inputClassName = "",
    buttonClassName = "",
    widthOpenClass = "w-48 md:w-64",
    initialOpen = false,
    autoFocusOnOpen = true
}: Props) {
    const [open, setOpen] = useState(initialOpen);
    const inputRef = useRef<HTMLInputElement | null>(null);

    function toggle() {
        setOpen(v => {
            const next = !v;
            if (!v && next && autoFocusOnOpen) setTimeout(() => inputRef.current?.focus(), 100);
            return next;
        });
    }

    return (
        <div className={`flex gap-1 items-center justify-end ${className}`}>
            <button
                type="button"
                onClick={toggle}
                className={`p-2 rounded-md hover:bg-gray-50 text-gray-600 ${buttonClassName}`}>
                <MagnifyingGlassIcon className="size-5"/>
            </button>
            <div className={`transition-all duration-300 ease-out overflow-hidden flex items-center ${open ? `${widthOpenClass} opacity-100 translate-x-0` : 'w-0 opacity-0 translate-x-0'}`}>
                <div className="relative w-full">
                    <input
                        ref={inputRef}
                        type="text"
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                        placeholder={placeholder}
                        className={`w-full rounded-md pr-8 pl-2 py-1.5 text-sm focus:outline-none ${inputClassName}`}
                    />
                    {value && (
                        <button
                            type="button"
                            onClick={() => {
                                onChange("");
                                toggle();
                            }}
                            className="absolute inset-y-0 right-2 my-auto h-5 w-5 flex items-center justify-center text-gray-400 hover:text-gray-600">
                            <XMarkIcon className="size-4 rounded-full hover:bg-gray-100"/>
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}
